/* MIRAMA X — choreography engine. No dependencies. */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(pointer: fine)').matches;

  /* ---------- Intro curtain: once per session, home only ---------- */
  var intro = document.querySelector('.mx-intro');
  if (intro) {
    var seen = false;
    try { seen = sessionStorage.getItem('mx-intro') === '1'; } catch (e) {}
    if (seen || reduced) {
      intro.remove();
    } else {
      try { sessionStorage.setItem('mx-intro', '1'); } catch (e) {}
      setTimeout(function () { intro.remove(); }, 2400);
    }
  }

  /* ---------- Word splitter for staggered headlines ---------- */
  document.querySelectorAll('[data-mx-split]').forEach(function (el) {
    if (reduced) return;
    var words = el.textContent.trim().split(/\s+/);
    el.textContent = '';
    words.forEach(function (word, i) {
      var mask = document.createElement('span');
      mask.className = 'mx-w';
      var inner = document.createElement('span');
      inner.style.setProperty('--mx-wi', i);
      inner.textContent = word;
      mask.appendChild(inner);
      el.appendChild(mask);
      if (i < words.length - 1) el.appendChild(document.createTextNode(' '));
    });
  });

  /* ---------- Reveal observer ---------- */
  var targets = document.querySelectorAll('[data-mx], [data-mx-split], .mx-stitch, .mx-clip, .mx-scene');
  if ('IntersectionObserver' in window && !reduced) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mx-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.18, rootMargin: '0px 0px -6% 0px' });
    targets.forEach(function (t) { io.observe(t); });
  } else {
    targets.forEach(function (t) { t.classList.add('mx-in'); });
  }

  /* ---------- Run infinite animations only while visible ---------- */
  var runners = document.querySelectorAll('.mx-strip, .mx-doc');
  if ('IntersectionObserver' in window && runners.length) {
    var runIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        entry.target.classList.toggle('mx-run', entry.isIntersecting);
      });
    }, { threshold: 0 });
    runners.forEach(function (r) { runIO.observe(r); });
  } else {
    runners.forEach(function (r) { r.classList.add('mx-run'); });
  }

  /* ---------- The thread: scroll progress ---------- */
  var thread = document.querySelector('.mx-thread__line');
  if (thread) {
    var ticking = false;
    var update = function () {
      var doc = document.documentElement;
      var max = doc.scrollHeight - window.innerHeight;
      var p = max > 0 ? Math.min(1, Math.max(0, window.scrollY / max)) : 0;
      thread.style.transform = 'scaleX(' + p + ')';
      ticking = false;
    };
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  /* ---------- Magnetic buttons (desktop, motion allowed) ---------- */
  if (fine && !reduced) {
    document.querySelectorAll('.mx-btn').forEach(function (btn) {
      var strength = 10;
      btn.addEventListener('pointermove', function (e) {
        var r = btn.getBoundingClientRect();
        var x = ((e.clientX - r.left) / r.width - 0.5) * strength;
        var y = ((e.clientY - r.top) / r.height - 0.5) * strength;
        btn.style.transform = 'translate(' + x + 'px,' + y + 'px)';
      });
      btn.addEventListener('pointerleave', function () {
        btn.style.transform = '';
      });
    });
  }

  /* ---------- Live date stamp (FI document specimen) ---------- */
  document.querySelectorAll('[data-mx-today]').forEach(function (el) {
    try {
      el.textContent = new Date().toLocaleDateString('en-US', {
        year: 'numeric', month: 'long', day: 'numeric'
      });
    } catch (e) {}
  });
})();
